/**
 * @generated SignedSource<<8ccb6ec00250987a87e0493ad9123a4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCharge_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodRoot_query" | "PaymentActive_query" | "PaymentCompleted_query" | "PaymentMethodBoletoSelected_query" | "PaymentMethodCreditCardSelected_query">;
  readonly " $fragmentType": "PaymentCharge_query";
};
export type PaymentCharge_query$key = {
  readonly " $data"?: PaymentCharge_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCharge_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCharge_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodRoot_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActive_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardSelected_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodBoletoSelected_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c1673f32b4623d9c22fb562c8c630ae7";

export default node;
